<script setup>
import InputError from "@/Components/InputError.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";
import InputField from "@/Components/InputField.vue";
import InputLabel from "@/Components/InputLabel.vue";

import { defineProps, ref, computed, watch } from "vue";
import Swal from "sweetalert2";
import { useForm } from "@inertiajs/vue3";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  jenis: {
    type: Object,
    required: true,
  },
  repository: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  nama_dok: "",
  jenis_dok: "",
  status: "",
  deskripsi: "",
  files: [],
});

function handleFileChange(e) {
  form.files = Array.from(e.target.files);
}
// Close modal
const closeModal = () => {
  emit("update:isOpen", false); // Emit event untuk menutup modal
};

// Handle click outside modal
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  if (form.id) {
    form.put(route("pelaporan.update", form.id), {
      onSuccess: () => {
        form.reset();
        Swal.fire({
          title: "Berhasil!",
          text: "Data berhasil diperbarui.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      },
    });
  } else {
    form.post(route("pelaporan.store"), {
      onSuccess: () => {
        form.reset();
        Swal.fire({
          title: "Berhasil!",
          text: "Data berhasil disimpan.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      },
      forceFormData: true,
    });
  }
};
</script>
<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50 sm:items-center sm:pt-0"
    @click="handleClickOutside"
  >
    <!-- Modal Container -->
    <div
      class="relative w-full h-auto max-h-[90vh] p-4 overflow-y-auto bg-white rounded-lg sm:w-1/2 sm:p-6"
    >
      <!-- Modal Header -->
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Modal Content -->
      <form class="space-y-4" @submit.prevent="submit">
        <!-- Nama Dokumen -->
        <div>
          <InputField
            label="Nama Dokumen"
            icon="pen"
            v-model.trim="form.nama_dok"
          />
          <InputError :message="form.errors.nama_dok" class="mt-2" />
        </div>

        <!-- Deskripsi -->
        <div>
          <label for="Deskripsi" class="block text-sm font-medium text-gray-700"
            >Deskripsi</label
          >
          <textarea
            class="w-full p-2 mt-1 text-sm border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Deskripsi"
            rows="4"
            v-model="form.deskripsi"
          ></textarea>
          <InputError :message="form.errors.deskripsi" class="mt-2" />
        </div>

        <!-- Jenis Dokumen -->
        <div>
          <label for="Jenis" class="block text-sm font-medium text-gray-700"
            >Jenis</label
          >
          <select
            v-model="form.jenis_dok"
            class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Pilih Jenis</option>
            <option v-for="jen in jenis.data" :key="jen.id" :value="jen.id">
              {{ jen.nama }}
            </option>
          </select>
          <InputError :message="form.errors.jenis_dok" class="mt-2" />
        </div>

        <!-- Kategori -->
        <div>
          <label for="Kategori" class="block text-sm font-medium text-gray-700"
            >Kategori</label
          >
          <select
            v-model="form.status"
            class="block w-full px-3 py-2 mt-1 text-sm text-gray-900 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="">Pilih Kategori</option>
            <option value="0">Eksternal</option>
            <option value="1">Internal</option>
          </select>
          <InputError :message="form.errors.status" class="mt-2" />
        </div>

        <!-- File Upload -->
        <div>
          <InputLabel
            for="gambar"
            value="File"
            class="block text-sm font-medium text-gray-700"
          />
          <input
            type="file"
            multiple
            @change="handleFileChange"
            class="block w-full mt-1 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer focus:ring-indigo-500 focus:border-indigo-500"
          />
          <progress
            v-if="form.progress"
            :value="form.progress.percentage"
            max="100"
            class="w-full mt-2"
          >
            {{ form.progress.percentage }}%
          </progress>
          <InputError :message="form.errors.file_path" class="mt-2" />
        </div>

        <!-- Submit Button -->
        <div class="mt-6">
          <PrimaryBtn :disabled="form.processing" class="w-full sm:w-auto">
            <i class="fa-solid fa-floppy-disk"></i> Simpan
          </PrimaryBtn>
        </div>
      </form>
    </div>
  </div>
</template>
